module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"title":"Facade Stops"}}')
  delete Component.options._Ctor
}
